import { createPackages } from '../Radiology/Constants/constants'
import '../../App.scss'

type Props = {
  onCreate: () => void
}

const PackageSearch = ({ onCreate }: Props) => {
  return (
    <div className='package-search-container'>
      <button className='btn btn-primaryBtn' onClick={onCreate}>
        {createPackages}
      </button>
    </div>
  )
}

export default PackageSearch
